import {PopupIds} from './PopupIds';

const siteIndexHashPopupWhitelist = [
    PopupIds.CARDHOLDERS_CREDENTIALS,
    PopupIds.EULA_POLICY,
    PopupIds.LOGIN,
    PopupIds.NEW_PASS,
    PopupIds.PAYMENT_POLICY,
    PopupIds.PRIVACY_POLICY,
    PopupIds.REFUND_POLICY,
    PopupIds.REGISTRATION,
    PopupIds.RESTORE_PASS,
    PopupIds.OTP_REQUEST_CODE,
    PopupIds.OTP_LOGIN,
    PopupIds.TERMS_OF_SERVICE,
    PopupIds.IMPRESSUM
];

const sitePlatformHashPopupWhitelist = [
    PopupIds.CARDHOLDERS_CREDENTIALS,
    PopupIds.EULA_POLICY,
    PopupIds.PAYMENT_POLICY,
    PopupIds.PRIVACY_POLICY,
    PopupIds.REFUND_POLICY,
    PopupIds.TERMS_OF_SERVICE
];

export default {
    SITE_INDEX: siteIndexHashPopupWhitelist,
    SITE_PLATFORM: sitePlatformHashPopupWhitelist
};
